import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import StarFilledIcon from '@ucheba/ui/icons/icon__star-filled.svg'
import { Button } from '@ucheba/ui/components/Button/desktop'

import { Text } from '@ucheba/ui/components/Text/desktop/Text'

const Divider = styled.div`
  height: 1px;
  background: ${sv.color.gray9};
`

const List = styled.ul`
  list-style: none;

  margin: 0;
  padding: 0;

  li {
    &:not(:first-of-type) {
      margin-top: 32px;
    }
  }
`
const ListTouch = styled(List)`
  li {
    &:not(:first-of-type) {
      margin-top: 24px;
    }
  }
`

const Details = styled.div`
  display: flex;
  flex-wrap: wrap;

  color: ${sv.color.gray50};
  font-size: ${sv.fontSize.medium};

  > *:not(:first-child):before {
    content: '•';
    margin: 0 5px;
    color: ${sv.color.gray25};
  }
`

const Responses = styled.div`
  margin-left: calc(64px + ${sv.spacing.small});

  ${sm.breakpoint.mdAndDown`
    margin-left: calc(32px + ${sv.spacing.xxsmall});
  `}
`

const UserNameBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
`

const Rating = styled(UserNameBlock)`
  column-gap: 8px;

  svg {
    margin-top: -4px;

    color: ${sv.color.orange};
  }
`

const RatingTouch = styled(UserNameBlock)`
  column-gap: 4px;
  margin-top: 0;

  svg {
    width: 20px;
    height: 20px;
    margin-top: -4px;

    color: ${sv.color.orange};
  }
`

const FeedbackHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0 12px 0;
`

const Stars = styled.div`
  display: flex;
  align-items: center;
`

const TextStyled = styled(Text)`
  line-height: 48px;
  cursor: pointer;
`

const StarFilledIconStyled = styled(StarFilledIcon)`
  color: ${sv.color.blue};
`

const ShowMoreButton = styled(Button)`
  margin-left: 80px;
  width: calc(100% - 80px);
`

const StarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }

  &:first-of-type {
    padding-left: 0;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`

const InstitutionRate = styled(Header)`
  margin-left: 16px;

  svg {
    width: 30px;
    height: 30px;

    color: ${sv.color.orange};
  }
`
const InstitutionRateTouch = styled(InstitutionRate)`
  margin-left: auto;

  svg {
    width: 30px;
    height: 30px;

    color: ${sv.color.orange};
  }
`

export {
  Divider,
  Details,
  Responses,
  UserNameBlock,
  Rating,
  FeedbackHeaderContainer,
  Controls,
  Stars,
  TextStyled,
  StarFilledIconStyled,
  StarWrapper,
  ShowMoreButton,
  RatingTouch,
  Header,
  InstitutionRate,
  List,
  ListTouch,
  InstitutionRateTouch,
}
